/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "srcEid",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "sender",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "nonce",
                type: "uint64",
            },
        ],
        name: "InboundNonceSkipped",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "srcEid",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "sender",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "nonce",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "payloadHash",
                type: "bytes32",
            },
        ],
        name: "PacketBurnt",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint32",
                name: "srcEid",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "sender",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "nonce",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "payloadHash",
                type: "bytes32",
            },
        ],
        name: "PacketNilified",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_oapp",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_srcEid",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "uint64",
                name: "_nonce",
                type: "uint64",
            },
            {
                internalType: "bytes32",
                name: "_payloadHash",
                type: "bytes32",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "eid",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_srcEid",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
        ],
        name: "inboundNonce",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_receiver",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_srcEid",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "uint64",
                name: "_nonce",
                type: "uint64",
            },
        ],
        name: "inboundPayloadHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_dstEid",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_receiver",
                type: "bytes32",
            },
        ],
        name: "nextGuid",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_oapp",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_srcEid",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "uint64",
                name: "_nonce",
                type: "uint64",
            },
            {
                internalType: "bytes32",
                name: "_payloadHash",
                type: "bytes32",
            },
        ],
        name: "nilify",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sender",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_dstEid",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_receiver",
                type: "bytes32",
            },
        ],
        name: "outboundNonce",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_oapp",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_srcEid",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "uint64",
                name: "_nonce",
                type: "uint64",
            },
        ],
        name: "skip",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
export class IMessagingChannel__factory {
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=IMessagingChannel__factory.js.map